module.exports = __webpack_public_path__ + "static/media/Angela.3eb0b2b6.png";